<!-- Status Badge - Shows for previous auctions OR individually closed horses in active auctions -->
<div class="status-badge-container author-and-btn-area mb-3" *ngIf="(aucType == 'previous' || isHorseClosed) && shouldShowStatus && !isNoStatusStatus && !isNoStatusSaleStatus">
  <app-auction-item-status
    [isPS]="isPSStatus"
    [isSold]="isSoldStatus"
    [isRna]="isRnaStatus"
    [isWinner]="isWinnerStatus"
    [isUnSold]="isUnSoldStatus"
    [isWithdrawn]="isWithdrawnStatus"
  ></app-auction-item-status>
</div>

<!-- Selling Info Section - Shows for previous auctions OR individually closed horses in active auctions -->
<div
  class="bid-info closed-bid-info"
  *ngIf="(aucType == 'previous' || isHorseClosed) && shouldShowStatus"
>
  <!-- Time Left: Ended -->
  <div class="bid-row bid-row-time-left">
    <span class="bid-label" data-translation-key="horse_view_time_left">
      {{ "horse_view.time_left" | translate }}
    </span>
    <span class="bid-amount" data-translation-key="horse_view_ended">
      {{ "horse_view.ended" | translate }}
    </span>
  </div>

  <!-- Price Display - Uses backend display_price -->
  <div class="bid-row bid-row-selling-price" *ngIf="horseDetails?.display_price">
    <span class="bid-label">
      <span *ngIf="isPSStatus" data-translation-key="horse_view_selling_price">
        {{ "horse_view.selling_price" | translate }}
      </span>
      <span *ngIf="!isRnaStatus && !isPSStatus" data-translation-key="horse_view_latest_bid">
        {{ "horse_view.latest_bid" | translate }}
      </span>
      <span *ngIf="isRnaStatus" data-translation-key="horse_info_highest_bid">
        {{ "horse_info.highest_bid" | translate }}
      </span>
    </span>
    <span class="bid-amount">
      {{
        horseDetails?.display_price?.amount || 0
          | customCurrency
            : (horseDetails?.display_price?.currency || currency?.currency_code)
            : locale
            : "symbol"
            : "1.0-0"
      }}
    </span>
  </div>

  <!-- No Status override (dash variant): show Latest Bid with dashes (no real outcome).
       The hide-price variant (no_status_hide_price) renders NO price row at all. -->
  <div class="bid-row bid-row-selling-price" *ngIf="isNoStatusStatus && !isNoStatusHidePriceStatus">
    <span class="bid-label" data-translation-key="horse_view_latest_bid">
      {{ "horse_view.latest_bid" | translate }}
    </span>
    <span class="bid-amount">----</span>
  </div>

  <!-- Winner/Buyer Info - Uses backend buyer_name (masked from backend).
       no_status_sale (legacy no-badge display) also shows the Highest Bidder. -->
  <ng-container *ngIf="(isSoldStatus || isWinnerStatus || isPSStatus || isNoStatusSaleStatus) && horseDetails?.expired">
    <div class="bid-row bid-row-highest-bidder">
      <span class="bid-label" data-translation-key="horse_view_highest_bidder">
        {{ "horse_view.highest_bidder" | translate }}
      </span>
      <span class="bid-amount">{{ horseDetails?.buyer_name || '*****' }}</span>
    </div>
    <div class="bid-row bid-row-seller">
      <span class="bid-label" data-translation-key="horse_view_seller">
        {{ "horse_view.seller" | translate }}
      </span>
      <span class="bid-amount">{{ horseDetails?.created_by_user_name }}</span>
    </div>
  </ng-container>

  <!-- RNA Status - Show seller info only -->
  <div class="bid-row bid-row-seller" *ngIf="isRnaStatus && horseDetails?.expired">
    <span class="bid-label" data-translation-key="horse_view_seller">
      {{ "horse_view.seller" | translate }}
    </span>
    <span class="bid-amount">{{ horseDetails?.created_by_user_name }}</span>
  </div>

  <!-- Not Sold - Show seller info only -->
  <div class="bid-row bid-row-seller" *ngIf="isUnSoldStatus && horseDetails?.expired">
    <span class="bid-label" data-translation-key="horse_view_seller">
      {{ "horse_view.seller" | translate }}
    </span>
    <span class="bid-amount">{{ horseDetails?.created_by_user_name }}</span>
  </div>
</div>
<div class="bid-info">
  <!-- <h5 class="timer-title" *ngIf="aucType == 'upcoming' || !canBid">
    {{ 'horse_view.horse_details' | translate }}
  </h5> -->
  <h5
    class="timer-title"
    *ngIf="aucType == 'active' && !isHorseClosed && (canBid || horseDetails?.notAuthBidBoard)"
    data-translation-key="horse_view_bid_board"
  >
    {{ "horse_view.bid_board" | translate }}
  </h5>
  <div class="bid-row" *ngIf="aucType == 'upcoming'">
    <div class="bid-label" data-translation-key="horse_view_starting_bid">
      <img src="../../../../../../../assets/images/bid-ico.svg" />
      {{ "horse_view.starting_bid" | translate }}
    </div>
    <span class="bid-amount">
      {{
        horseDetails?.min_bid || horseDetails?.auction_min_bid
          ? (horseDetails?.min_bid || horseDetails?.auction_min_bid
            | customCurrency
              : currency?.currency_code
              : locale
              : "symbol"
              : "1.0-0")
          : "-"
      }}
    </span>
  </div>
  <div class="bid-row" *ngIf="aucType == 'active' && !isHorseClosed">
    <div class="bid-label" data-translation-key="horse_info_current_bid">
      <img src="../../../../../../../assets/images/bid-ico.svg" />
      {{ "horse_info.current_bid" | translate }}
    </div>
    <span class="bid-amount" *ngIf="horseDetails.bidders_count"
      >{{
        horseDetails.highest_bid_amount
          | customCurrency
            : currency?.currency_code
            : locale
            : "symbol"
            : "1.0-0"
      }}
    </span>
    <span class="bid-amount" *ngIf="!horseDetails.bidders_count"
      >{{
        "0"
          | customCurrency
            : currency?.currency_code
            : locale
            : "symbol"
            : "1.0-0"
      }}
    </span>
  </div>

  <!-- <hr *ngIf="aucType == 'active' && canBid" /> -->
  <div
    class="bid-row"
    *ngIf="aucType == 'active' && !isHorseClosed && (canBid || horseDetails?.notAuthBidBoard)"
  >
    <span class="bid-label" data-translation-key="horse_view_starting_bid">
      {{ "horse_view.starting_bid" | translate }}
    </span>

    <span class="bid-amount"
      >{{
        horseDetails?.min_bid || horseDetails?.auction_min_bid
          ? (horseDetails?.min_bid || horseDetails?.auction_min_bid
            | customCurrency
              : currency?.currency_code
              : locale
              : "symbol"
              : "1.0-0")
          : "-"
      }}
    </span>
  </div>
  <div
    class="bid-row"
    *ngIf="aucType == 'active' && !isHorseClosed && (canBid || horseDetails?.notAuthBidBoard)"
  >
    <span class="bid-label" data-translation-key="horse_view_next_minimum_bid">
      {{ "horse_view.next_minimum_bid" | translate }}
    </span>

    <span class="bid-amount"
      >{{
        horseDetails.nextMinBid
          | customCurrency
            : currency?.currency_code
            : locale
            : "symbol"
            : "1.0-0"
      }}
    </span>
  </div>
</div>

<!-- <hr *ngIf="aucType == 'upcoming' || !canBid" /> -->
<ng-content select="[activeDetails]"></ng-content>
<ng-container
  *ngIf="aucType != 'previous' && !isHorseClosed && horseDetails?.withdrawn_at == null"
>
  <app-request-to-bid-button
    class="w-100"
    [loggedIn]="loggedIn"
    [auctionSettings]="auctionSettings"
    [translations]="translations"
    [horseDetails]="horseDetails"
    [aucType]="aucType"
    [terms]="terms"
    (fetchData)="handleLoadData()"
    [buyerStatus]="buyerStatus"
    [sellerEmail]="sellerEmail"
    [canBid]="canBid"
  ></app-request-to-bid-button>
  <!-- [terms]="{
    buyer_accepted: terms?.buyer_accepted,
    seller_terms: terms?.seller_terms
  }" -->
</ng-container>
<!-- Show Make Offer for previous auctions OR individually closed horses in active auctions -->
<ng-container
  *ngIf="
    (aucType == 'previous' || isHorseClosed) &&
    (isUnSoldStatus || isRnaStatus || !!horseDetails?.unsold_flag_at) &&
    !horseOffers?.make_an_offer?.item_has_accepted_offer &&
    horseOffers?.make_an_offer?.time_window_days > 0
  "
>
  <app-make-offer-btn
    class="w-100"
    [translations]="translations"
    [dir]="dir"
    [horseId]="horseDetails?.id"
    [isDisabled]="
      !horseOffers?.make_an_offer?.is_available &&
      horseOffers?.make_an_offer.time_window_days != 0
    "
    [currencyLocal]="{ locale: locale, currency: currency }"
  ></app-make-offer-btn>
</ng-container>

<div class="footer-links">
  <a
    *ngIf="!horseDetails?.in_user_wishlist"
    class="footer-link"
    (click)="addToWishList()"
    data-translation-key="horse_view_add_short_list"
  >
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00013 3.32629L7.32792 2.63535C5.75006 1.01348 2.85685 1.57317 1.81244 3.61222C1.32211 4.57128 1.21149 5.95597 2.10683 7.72315C2.96935 9.42471 4.76378 11.4628 8.00013 13.6828C11.2365 11.4628 13.03 9.42471 13.8934 7.72315C14.7888 5.95503 14.6791 4.57128 14.1878 3.61222C13.1434 1.57317 10.2502 1.01254 8.67234 2.63441L8.00013 3.32629ZM8.00013 14.8125C-6.375 5.31378 3.57406 -2.09995 7.83512 1.8216C7.89138 1.87317 7.94669 1.9266 8.00013 1.98192C8.05303 1.92665 8.10807 1.87349 8.16513 1.82254C12.4253 -2.10182 22.3753 5.31284 8.00013 14.8125Z"
      />
    </svg>
    {{ "horse_view.add_short_list" | translate }}
  </a>
  <a
    *ngIf="horseDetails?.in_user_wishlist"
    class="footer-link"
    (click)="removeFromWishList()"
    data-translation-key="horse_view_remove_short_list"
  >
    <svg
      width="16"
      height="15"
      viewBox="0 0 16 15"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00013 3.32629L7.32792 2.63535C5.75006 1.01348 2.85685 1.57317 1.81244 3.61222C1.32211 4.57128 1.21149 5.95597 2.10683 7.72315C2.96935 9.42471 4.76378 11.4628 8.00013 13.6828C11.2365 11.4628 13.03 9.42471 13.8934 7.72315C14.7888 5.95503 14.6791 4.57128 14.1878 3.61222C13.1434 1.57317 10.2502 1.01254 8.67234 2.63441L8.00013 3.32629Z"
        fill="#062106"
      />
    </svg>
    {{ "horse_view.remove_short_list" | translate }}
  </a>
</div>
<!-- </div> -->
